var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.inital
    ? _c(
        "div",
        { staticClass: "component-small-class" },
        [
          _vm._m(0),
          _c(
            "VideoPlayer",
            { attrs: { videos: _vm.videos, isPaid: _vm.isPaid } },
            [
              _vm.isPaid
                ? _c(
                    "Button",
                    {
                      staticClass: "download-btn",
                      attrs: { slot: "download", skin: "grey" },
                      on: {
                        click: function($event) {
                          return _vm.$windowOpen(_vm.pdf)
                        }
                      },
                      slot: "download"
                    },
                    [_vm._v("下载课程脑图")]
                  )
                : _vm._e()
            ],
            1
          ),
          _c("p", { staticClass: "text1 color-gray-2 mt-24" }, [
            _vm._v(
              " “收到哈佛Offer”，“周游世界”，“实现一个亿小目标”，哪件事会让你感到无比幸福？如果告诉你，这些事可能并不能使你感到幸福，你会怎么想？ "
            )
          ]),
          _c("p", { staticClass: "text1 color-gray-2 mt-10" }, [
            _vm._v(
              " 很难想象，简简单单的“happiness”会成为哈佛大学研究了将近80年的命题。而《幸福心理学》这门课在哈佛曾经连续N年蝉联全校最多人选、而且出席率奇高，几乎每一节都是千人爆满的状态。 "
            )
          ]),
          _c("p", { staticClass: "text1 color-gray-2 mt-10" }, [
            _vm._v(
              " 幸福的本质究竟是什么？不幸福的根本原因又包含什么？财富和成功，在多大程度上能带给人长久的幸福感？在全球环境快速变化的今天，我们怎样可以掌控自己的幸福？又有哪些获得幸福的“捷径”？ "
            )
          ]),
          _c("p", { staticClass: "text1 color-gray-2 mt-10" }, [
            _vm._v(
              " 就连哈佛学霸这样的“别人家孩子”都视作刚需的《幸福心理学》，那些考纲和心灵鸡汤不教你的心理学知识，来这堂哈佛在线课一起学习吧。 "
            )
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("h1", { staticClass: "h1 color-gray-1" }, [
      _vm._v(" 幸福心理学 "),
      _c("br", { staticClass: "m-only" }),
      _c("span", { staticClass: "color-gray-4" }, [
        _vm._v("Positive Psychology")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }